import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IEmployee, Employee } from 'cm-angular-org-chart/lib/employee';
import {
  IUsarioPerfilDto,
  IPerfilResponse,
  IAlterarPerfilDto,
  IDesativarPerfilDto,
} from '../model/interfaces-perfil';
import { PerfisService } from '../perfis.service';
import { IIndiceRemissivo, IPersmissaoSelect, IPermissao } from '../permissao';
import * as XLSX from 'xlsx';
import { IUsuarioArmazenamentoLocal } from "../model/usuario-sso-model";

@Component({
  selector: 'app-mostrar-editar-perfil',
  templateUrl: './mostrar-editar-perfil.component.html',
  styleUrls: ['./mostrar-editar-perfil.component.scss'],
})
export class MostrarEditarPerfilComponent {
  modoVisao: boolean = true;
  usuario!: IUsuarioArmazenamentoLocal;
  permissoesAcessoUsuario!: Array<number>;

  listaUsuariosDoPerfil: IUsarioPerfilDto[] = [];
  public paginaAtual = 1;

  mensagens?: Array<string>;
  statusSucesso: string | 'alert-success' = 'alert-success';

  perfil!: IPerfilResponse;
  listaPermissoes?: Array<number> = [];

  routeState: any;

  arvoreSendoMostrada: any = null;
  alphabet: string[] = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  indiceRemissivo: IIndiceRemissivo[] = [];
  indiceRemissivoFiltrado: IIndiceRemissivo[] = [];

  selecoes: IPersmissaoSelect[] = [];
  /*
      var itensRemocao = ['PortalPrincipal', 'Menu Linha1', 'Menu Linha2', 'Perfis']
  
      p.caminho = p.caminho.filter((item) => !itensRemocao.includes(item));
  */

  permissoesSelecionadas: IPermissao[] = [];

  private classeMarcado = 'oc-me';
  private classeDesmarcado = 'oc-junior';

  private iconMarcado = 'assets/img/ico-options.png';
  private iconDesmarcado = 'assets/img/ico-breadcrumb.png';

  constructor(private service: PerfisService, private router: Router) {
    this.getDadosUsuario();
    this.routeState = this.router.getCurrentNavigation()?.extras.state;

    if (this.routeState) {
      this.perfil = this.routeState.perfil;
      this.listaUsuariosDoPerfil = this.perfil.usuarios || [];
      this.modoVisao = this.routeState.modoVisao;
      this.getListaPermissoes();
    } else this.router.navigate(['/perfis']);
  }


  getDadosUsuario() {
    try {
      this.service.getUsuarioLocalStorage().subscribe((r) => {
        this.usuario = r;
        this.permissoesAcessoUsuario = r.permissoes.map((p) => p.codigoPermissao);
        this.permissoesAcessoUsuario =[...this.permissoesAcessoUsuario, 0];
        console.log('permissoesAcessoUsuario', this.permissoesAcessoUsuario);


      });
    } catch {
      this.statusSucesso = 'alert-danger'
      this.mensagens = ['Erro nos dados de consulta do usuário!']
    }
  }

  private getListaPermissoes(): void {
    this.service
      .getListaPermissoes({
        codPerfil: this.perfil?.codperfil || 0
      }, this.usuario.guid)
      .subscribe((r) => {
        if (r.sucesso) {
          this.listaPermissoes = r.retorno;
          this.getPerfis();
        } else {
          this.mensagens = r.mensagens;
          this.statusSucesso = 'alert-danger';
        }
      });
  }


  private getPerfis(): void {
    this.service.getPerfis(this.usuario).subscribe((p) => {
      let decoded = this.service.fromBinary(p.fileContents) //

      var res = this.createMapping(decoded);

      this.alphabet.forEach((letra) => {
        var l: IIndiceRemissivo = { letra: letra, permissoes: [] };
        l.permissoes = res.filter((p) => p.nomePermissao?.startsWith(letra));
        if(letra == 'M') console.log(l.permissoes)
        this.indiceRemissivo.push(l);
      });

      res.forEach((p) => {
        const ultimoValor = p.ids[p.ids.length - 1];
        if (this.listaPermissoes?.includes(ultimoValor)) {
          p.selecionado = true;
          this.oreganizarSelecoes(p);
        }
      });

      this.searchObjects('');
    });
  }




  marcarDesmarcarSubordinados(
    e: IEmployee,
    marcar: string,
    icone: string,
    permissao: boolean
  ) {
    e.cssClass = marcar;
    e.imageUrl = icone;
    this.ajustarPermissoesSelecionadas(e, permissao);

    if (e.subordinates.length > 0) {
      e.subordinates.forEach((subordinado: any) => {
        this.marcarDesmarcarSubordinados(subordinado, marcar, icone, permissao);
      });
    }
  }

  ajustarPermissoesSelecionadas(e: IEmployee, adicionar: boolean = true) {
    let p: IPermissao;
    p = { id: e.designation, nome: e.name, url: e.imageUrl };

    this.permissoesSelecionadas = this.permissoesSelecionadas.filter(
      (p) => p.id !== e.designation
    );

    if (adicionar) this.permissoesSelecionadas.push(p);
  }

  findAncestors(tree: IEmployee, designation: string): IEmployee[] {
    if (tree.designation === designation) {
      return [tree];
    }

    for (const subordinate of tree.subordinates) {
      const ancestors = this.findAncestors(subordinate, designation);
      if (ancestors.length > 0) {
        return [tree, ...ancestors];
      }
    }

    return [];
  }

  onClickItemE(e: Employee) {

    let addPermissao = true;

    // Definindo classes e icones para marcados ou desmarcados
    if (e.cssClass === this.classeMarcado) {
      e.cssClass = this.classeDesmarcado;
      e.imageUrl = this.iconDesmarcado;
      addPermissao = false;
    } else {
      e.cssClass = this.classeMarcado;
      e.imageUrl = this.iconMarcado;
    }

    e.subordinates.forEach((subordinado: any) => {
      this.marcarDesmarcarSubordinados(
        subordinado,
        e.cssClass,
        e.imageUrl,
        addPermissao
      );
    });

    if (e.cssClass !== this.classeDesmarcado) {
      var id = e.designation || '';
      var antecessores = this.findAncestors(this.arvoreSendoMostrada, id);

      var c = antecessores.filter((a) => a.designation !== id);
      c.forEach((antecessor) => {
        antecessor.cssClass = e.cssClass;
        antecessor.imageUrl = e.imageUrl;
        this.ajustarPermissoesSelecionadas(antecessor, addPermissao);
      });
    }

    this.ajustarPermissoesSelecionadas(e, addPermissao);
  }
  oreganizarSelecoes(item: IPersmissaoSelect) {
    this.selecoes = this.selecoes.filter((s) => s.ids !== item.ids);


    if (item.selecionado) {
      this.selecoes.push(item);
    }
  }

  marcarComoSelecionado(arg0: any) {
    let marcado = arg0.selecionado;
    let ids = arg0.ids;
    const ultimoValor = ids[ids.length - 1];

    this.indiceRemissivo.forEach((ind) => {
      ind.permissoes.forEach((item) => {
        let s = item.ids[item.ids.length - 1];

        if (marcado) {
          if (ids.includes(s)) {
            item.selecionado = marcado;
            this.oreganizarSelecoes(item);
          }
        }

        if ((item.ids as number[]).includes(ultimoValor)) {
          item.selecionado = marcado;
          this.oreganizarSelecoes(item);
        }
      });
    });

    this.indiceRemissivoFiltrado.forEach((ind) => {
      ind.permissoes.forEach((item) => {
        let s = item.ids[item.ids.length - 1];

        if (marcado) {
          if (ids.includes(s)) {
            item.selecionado = marcado;
          }
        }

        if ((item.ids as number[]).includes(ultimoValor)) {
          item.selecionado = marcado;
        }
      });
    });
  }

  

  formatarCaminhoLongo(p: IPersmissaoSelect, solicitante: string = 'lista'): string {
console.log('lista')
    return solicitante == 'lista'
      ?this.service.formatarCaminho(p, this.usuario.guid)
      :this.service.formatarCaminhoSelecionados(p, this.usuario.guid);
  }

  /*
    mostrarSequencia(e: IEmployee) {
      this.onClickItemE(e);
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(this.menuPrincipal.subordinates[this.numeroMenu])
      );
  
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.arvoreSendoMostrada.subordinates.find(
            (t: any) => t.designation === e.designation
          )
        )
      );
      this.mostrarArvoreSelecionada = true;
    }
  */
  /*
  convertXmlToJson(xml: string): void {
    const xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
    const json: any[] = [];

    function parseNode(node: Element): any {
      const obj: any = {};
      //const attributes = node.attributes;
      const designation = node.getAttribute('Cod_Permissao');
      const indPrivado = node.getAttribute('Ind_Privado');
      const dscPermissao = node.getAttribute('Dsc_Permissao');
      const dscObjeto = node.getAttribute('Dsc_Objeto');
      const name = node.getAttribute('Dsc_Permissao');
      const dscUrl = node.getAttribute('Dsc_URL');
      const tipo = node.getAttribute('tipo');

      if (tipo === '3') return null;

      obj.designation = designation;
      obj.indPrivado = indPrivado;
      obj.dscPermissao = dscPermissao;
      obj.dscObjeto = dscObjeto;
      obj.name = name;
      obj.dscUrl = dscUrl;
      obj.tipo = tipo;
      obj.cssClass = 'oc-junior';

      obj.subordinates = [];

      const childNodes = node.childNodes;

      for (let i = 0; i < childNodes.length; i++) {
        const childNode = childNodes[i];

        if (childNode.nodeType === Node.ELEMENT_NODE) {
          var r = parseNode(childNode as Element);
          if (r !== null) {
            obj.subordinates.push(r);
          }
        }
      }

      return obj;
    }

    const rootNodes = xmlDoc.getElementsByTagName('Permissao');
    json.push(parseNode(rootNodes[0]));
    this.menuPrincipal = json[0];
    this.arvoreOriginal = JSON.parse(JSON.stringify(json[0]));

  }
*/
  exportTableToExcel(tableId: string, fileName: string): void {
    if (this.listaUsuariosDoPerfil.length > 0) {
      const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        this.listaUsuariosDoPerfil
      );
      const workBook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, tableId);
      XLSX.writeFile(workBook, `${fileName}.xlsx`);
    }
  }

  createMapping(xml: string): IPersmissaoSelect[] {
    const xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
    const mapping: any[] = [];

    function traverse(node: Element, path: any[], ids: any[], permissoesAcessoUsuario: Array<number>) {
      let obj: IPersmissaoSelect = {
        nomePermissao: node.getAttribute('Dsc_Permissao'),
        url: node.getAttribute('Dsc_URL'),
        caminho: [...path, node.getAttribute('Dsc_Permissao')],
        ids: [...ids, parseInt(node.getAttribute('Cod_Permissao') || '0')],
        selecionado: false,
      };

      var tipo = parseInt(node.getAttribute('tipo') || '-1');
      var codPermissao = parseInt(node.getAttribute('Cod_Permissao') || '-1');

      // Verificar se o tipo é diferente de 3 e -1 e se o código da permissão está na lista de permissões do usuário
      if (![-1, 3].includes(tipo) && ![-1].includes(codPermissao) && permissoesAcessoUsuario.includes(codPermissao))
        mapping.push(obj);

      const children = node.children;
      for (let i = 0; i < children.length; i++) {
        traverse(
          children[i],
          [...path, node.getAttribute('Dsc_Permissao')],
          [...ids, parseInt(node.getAttribute('Cod_Permissao') || '0')],
          permissoesAcessoUsuario
        );
      }
    }
    traverse(xmlDoc.documentElement, [], [], this.permissoesAcessoUsuario);

    return mapping;
  }

  searchObjects(filtro: string) {
    if (filtro.trim() !== '') {

      const searchResults: IIndiceRemissivo[] = [];

      this.indiceRemissivo.forEach((obj) => {
        const filteredPermissoes = obj.permissoes.filter((p) =>
          this.removeAccents(p.nomePermissao)
            .toLowerCase()
            .includes(this.removeAccents(filtro.trim()).toLowerCase())
        );

        if (filteredPermissoes.length > 0) {
          const newObj: IIndiceRemissivo = {
            letra: obj.letra,
            permissoes: filteredPermissoes,
          };

          searchResults.push(newObj);
        }
      });

      this.indiceRemissivoFiltrado = JSON.parse(JSON.stringify(searchResults));

    } else
      this.indiceRemissivoFiltrado = JSON.parse(
        JSON.stringify(this.indiceRemissivo)
      );
  }

  removeAccents(nomePermissao: string | null): string {
    if (nomePermissao === null) return '';
    return nomePermissao.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  salvarPerfil(): void {

    this.listaPermissoes = [];

    this.selecoes.forEach((s) => {
      s.ids.forEach((id) => {
        this.listaPermissoes?.includes(id)
          ? null
          : this.listaPermissoes?.push(id);
      });
    });

    this.listaPermissoes = this.listaPermissoes?.filter((x) => x != 0);

    let incluirPerfilDto: IAlterarPerfilDto = {
      dscLogin: this.usuario.login,
      lstPermissoes: this.listaPermissoes || [],
      codperfil: this.perfil?.codperfil || 0,
    };

    this.service.alterarPerfil(incluirPerfilDto, this.usuario.guid).subscribe((r) => {
      if (r.sucesso) {
        console.log(r);
        this.mensagens = [r.retorno?.erro || 'Perfil atualizado com sucesso!'];
        this.statusSucesso = 'alert-success';
      } else {
        this.mensagens = r.mensagens;
        this.statusSucesso = 'alert-danger';
      }
    });
  }

  desativarPerfil() {
    //this.loading = true;
    let desativarPerfilDto: IDesativarPerfilDto = {
      codperfil: this.perfil?.codperfil || 0,
      lstPermissoes: [],
      dscLogin: this.usuario.login,
    };
    this.service.desativarPerfil(desativarPerfilDto, this.usuario.guid).subscribe((r) => {
      if (r.sucesso) {
        this.mensagens = [r.retorno?.erro || 'Perfil desativado com sucesso!'];
        this.statusSucesso = 'alert-success';
        this.router.navigate(['/perfis']);
      } else {
        this.mensagens = [
          `Houveram erros ao desativar o perfil: "${this.perfil?.dscperfil}".`,
          ...r.mensagens,
        ];
        this.statusSucesso = 'alert-danger';
      }
    });
  }
}
